// ./../common/TimerButton.jsx
import React from "react";
import PropTypes from "prop-types";

const TimerButton = ({ countdown, disabled }) => {
  // Format countdown as MM:SS
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60)
      .toString()
      .padStart(1, "0");
    const secs = (seconds % 60).toString().padStart(2, "0");
    return `${mins}:${secs}`;
  };

  return (
    <button
      className="common-button timer-button"
      disabled={disabled}
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      {countdown > 0 ? formatTime(countdown) : "0:00"}
    </button>
  );
};

TimerButton.propTypes = {
  countdown: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default TimerButton;
